import { render } from "./ChartDetails.vue?vue&type=template&id=693dd54c&scoped=true"
import script from "./ChartDetails.vue?vue&type=script&lang=js"
export * from "./ChartDetails.vue?vue&type=script&lang=js"

import "./ChartDetails.vue?vue&type=style&index=0&id=693dd54c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693dd54c"]])

export default __exports__